import React, { useEffect, useState } from "react";
import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";
import Dashboard_Card from "../components/Dashboard_Card";
import Graph_card from "../components/Graph_card";
import PI_chart from "../components/PI_chart";
import { useAuth } from "../context/AuthContext";


const API_URL = process.env.REACT_APP_API_URL;

export default function Dashboard() {
  const { user } = useAuth();

  const [count, setCount] = useState([]);
  const [center_list, setCenter_list] = useState([]);
  const [counts, setCounts] = useState({
    total: 0,
    IUI: 0,
    IVF: 0,
    ICSI: 0,
  });
  const [graphData, setGraphData] = useState([]);
  const [pieData, setPieData] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    axios
      .get(`${API_URL}/get_sample_table_list`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log("API Response:", res.data);
        setCenter_list(res.data.center_list || []);
        setCount(res.data.count || {});
      })
      .catch((err) => console.error("API Error:", err));
  }, []);



  // ===== FILTER + COUNT =====
  useEffect(() => {
    if (!user || user.active !== "0") return;

    const userRole = String(user.role);
    const userId = String(user.uid);

    // Filter based on user role
    const filteredData =
      userRole === "1"
        ? [...center_list] // Admin → all records
        : center_list.filter((item) => String(item.user_id) === userId); // Normal user → own records

    console.log("Filtered Data:", filteredData);

    // Initialize counters
    let total = filteredData.length;
    let count_iui = 0;
    let count_ivf = 0;
    let count_icsi = 0;

    // let count_ngp = 0;
    // let count_luc = 0;
    // let count_nwd = 0;
    // let count_jod = 0;

    filteredData.forEach((item) => {
      const procedure = item.procedure_type || "";

      // Count procedures
      if (procedure === "IUI") count_iui++;
      if (procedure === "IVF") count_ivf++;
      if (procedure === "ICSI") count_icsi++;

      // Extract center from sample_code (first part before '/')
      // const center = center_id.split("/")[0];

      // if (center === "NGP") count_ngp++;
      // if (center === "LUC") count_luc++;
      // if (center === "NWD") count_nwd++;
      // if (center === "JOD") count_jod++;
    });

    setCounts({
      total,
      IUI: count_iui,
      IVF: count_ivf,
      ICSI: count_icsi,
    });

    setGraphData([
      { label: "Nagpur", value: count.Nagpur, color: "#00b0ff" },
      { label: "Jodhpur", value: count.Jodhpur, color: "#ff1744" },
      { label: "Lucknow", value: count.Lucknow, color: "#76ff03" },
      { label: "Delhi", value: count.Delhi, color: "#ffeb3b" },
    ]);

    // setPieData([
    //   { label: "IUI", value: count_iui, color: "#e53935" },
    //   { label: "IVF", value: count_ivf, color: "#43a047" },
    //   { label: "ICSI", value: count_icsi, color: "#1e88e5" },
    // ]);

    const iui = Number(count_iui) || 0;
    const ivf = Number(count_ivf) || 0;
    const icsi = Number(count_icsi) || 0;

    if (count.IUI === 0 && count.IVF === 0 && count.ICSI === 0) {
      setPieData([
        { label: "Data Not Available", value: 100, color: "orange" },
      ]);
    } else {
      setPieData([
        { label: "IUI", value: count.IUI, color: "#e53935" },
        { label: "IVF", value: count.IVF, color: "#43a047" },
        { label: "ICSI", value: count.ICSI, color: "#1e88e5" },
      ]);
    }


  }, [user, center_list]);

  return (
    <>
      {/* <Container fluid className="mt-1" style={{ border: "1px solid black" }}> */}
      <Container fluid className="mt-3 p-4 bg-light rounded-4 shadow-sm" >
        <h6
          style={{
            textAlign: "left",
            marginBottom: "12px",
            fontWeight: "500",
            color: "#333",
          }}
        >
          Study Center:{" "}
          <span
            style={{
              fontWeight: "700",
              color: "#4a148c",
            }}
          >
            {user?.center_name}
          </span>
        </h6>
        <Row className="g-3">
          <Col xs={12} sm={6} lg={3}>
            <Dashboard_Card
              title="Samples"
              value={counts.total}
              icon="bi bi-people-fill"
              color="#4a148c"
              bgColor="#6a1b9a"
            ></Dashboard_Card>
          </Col>

          <Col xs={12} sm={6} lg={3}>
            <Dashboard_Card
              title="IUI"
              value={counts.IUI}
              icon="bi bi-heart-pulse-fill"
              color="#00796b"
              bgColor="#009688"
            ></Dashboard_Card>
          </Col>

          <Col xs={12} sm={6} lg={3}>
            <Dashboard_Card
              title="IVF"
              value={counts.IVF}
              icon="bi bi-eyedropper"
              color="#f57c00"
              bgColor="#ff9800"
            ></Dashboard_Card>
          </Col>

          <Col xs={12} sm={6} lg={3}>
            <Dashboard_Card
              title="ICSI"
              value={counts.ICSI}
              icon="bi bi-capsule"
              color="#d32f2f"
              bgColor="#f44336"
            ></Dashboard_Card>
          </Col>
        </Row>
      </Container>


      {/* <Container fluid className="mt-3" style={{ border: "1px solid green" }}> */}
      <Container fluid className="mt-3 p-4 bg-light rounded-4 shadow-sm" >


        <Row className="g-3 mt-1">
          <Col xs={12} lg={6}>
            <Graph_card data={graphData} />
          </Col>
          <Col xs={12} lg={6}>
            <PI_chart data={pieData} />
          </Col>
        </Row>
      </Container></>
  );
}
